var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 86.17 c -0.227 0 -0.454 -0.052 -0.664 -0.156 C 12.442 70.067 0.531 47.129 0.018 30.981 c -0.337 -10.615 4.02 -19.605 11.654 -24.048 C 20.528 1.778 32.336 3.079 45 10.584 c 12.662 -7.505 24.471 -8.805 33.328 -3.65 c 7.634 4.443 11.991 13.433 11.654 24.048 c -0.513 16.148 -12.424 39.086 -44.318 55.033 C 45.454 86.118 45.227 86.17 45 86.17 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(215,90,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.556 39.147 c -0.634 0 -1.221 -0.41 -1.417 -1.048 c -2.233 -7.258 -0.825 -15.183 3.587 -20.188 c 3.152 -3.577 7.496 -5.188 11.923 -4.415 c 0.807 0.141 1.347 0.909 1.206 1.716 c -0.141 0.807 -0.914 1.345 -1.716 1.206 c -3.431 -0.599 -6.696 0.629 -9.187 3.455 c -3.745 4.248 -4.914 11.06 -2.977 17.354 c 0.241 0.783 -0.198 1.613 -0.982 1.854 C 11.847 39.126 11.7 39.147 11.556 39.147 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(233,125,111)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveFill);
export default __webpack_public_path__ + "static/media/love-fill.7f100abb7ac7df4a261745fa63427404.svg";
export { ForwardRef as ReactComponent };